/**
 * 用户角色相关公共判断，全项目共用这一份，权限规则变化只需要改这里
 * 角色枚举（登录接口返回，存于 localStorage）：MANAGER("manager")、VIP_USER("vip")
 */

/**
 * 判断当前用户是否可见"模型推荐 / 推荐号码"相关功能
 * 仅管理员(manager)、VIP 用户(vip)可见
 * @returns {boolean} 是否可见
 */
export function canShowModelRec() {
  const role = localStorage.getItem('userRole')
  return role === 'manager' || role === 'vip'
}
